import { FC } from "react";
import MainNav from "./MainNav";

export interface HeaderProps {
  navType?: "MainNav1" | "MainNav2";
  className?: string;
}

const Header: FC<HeaderProps> = ({ navType = "MainNav1", className = "" }) => {
  return (
    <>
      <div
        className={`nc-Header   sticky top-0 w-full left-0 right-0 z-10 ${className}`}
      >
        <MainNav />
      </div>
    </>
  );
};

export default Header;
